(function (angular) {
  var integerDirectiveId = "pcmInteger";
  var numberDirectiveId = "pcmNumber";
  var rangeDirectiveId = "pcmRange";
  var accountInUseDirectiveId = "pcmAccountInUse";
  var uniqueAccountNameDirectiveId = "pcmUniqueAccount";
  var verificationTokenDirectiveId = "pcmVerificationToken";
  var matchDirectiveId = "pcmCompareField";

  angular
    .module("app")
    .directive(integerDirectiveId,
      function () {
        return {
          require: "ngModel",
          link: function (scope, elm, attrs, ctrl) {
            var INTEGER_REGEXP = /^\-?\d+$/;

            function integerValidation(val) {

              if (val == null || val === "") {
                ctrl.$setValidity("pcmInteger", true);
                return val;
              }

              if (INTEGER_REGEXP.test(val)) {
                ctrl.$setValidity("pcmInteger", true);
                return parseInt(val);
              } else {
                ctrl.$setValidity("pcmInteger", false);
                return undefined;
              }
            }

            ctrl.$parsers.unshift(integerValidation);
            ctrl.$formatters.unshift(integerValidation);
          }
        };
      });

  angular
    .module("app")
    .directive(numberDirectiveId,
      function () {
        return {
          require: "ngModel",
          link: function (scope, elm, attrs, ctrl) {
            var NUM_REGEXP = /^\-?\d+((\.|\,)\d+)?$/;

            function numberValidation(val) {
              if (val == null || val === "") {
                ctrl.$setValidity("pcmNumber", true);
                return val;
              }

              if (typeof val === "number") {
                val = val.toString();
              }

              if (NUM_REGEXP.test(val)) {
                ctrl.$setValidity("pcmNumber", true);
                return parseFloat(val.replace(",", "."));
              } else {
                ctrl.$setValidity("pcmNumber", false);
                return undefined;
              }
            }

            ctrl.$parsers.unshift(numberValidation);
            ctrl.$formatters.unshift(numberValidation);
          }
        };
      });

  angular
    .module("app")
    .directive(rangeDirectiveId,
      function () {
        return {
          require: "ngModel",
          link: function (scope, elm, attrs, ctrl) {
            scope.$watch(function () {
              return attrs.pcmRangeMin;
            }, function () {
              ctrl.$validate();
            });
            scope.$watch(function () {
              return attrs.pcmRangeMax;
            }, function () {
              ctrl.$validate();
            });

            function rangeValidation(val) {
              var min = parseFloat(attrs.pcmRangeMin);
              var max = parseFloat(attrs.pcmRangeMax);
              if (val == null || val === "") {
                ctrl.$setValidity("pcmRange", true);
                return val;
              }

              if ((min !== undefined) && (max !== undefined)) {
                val = parseFloat(val);
                if ((val >= min) && (val <= max)) {
                  ctrl.$setValidity("pcmRange", true);
                  return val;
                } else {
                  ctrl.$setValidity("pcmRange", false);
                  return undefined;
                }
              }
            }

            ctrl.$parsers.unshift(rangeValidation);
            ctrl.$formatters.unshift(rangeValidation);
          }
        };
      });

  // idea from: http://stackoverflow.com/questions/24385104/password-matching-in-angularjs-using-the-validators-pipeline-produces-unexpecte
  angular
    .module("app")
    .directive(matchDirectiveId, function () {
      var d = {
        restrict: "A",
        require: "ngModel",
        scope: {},
        link: function (scope, element, attr, control) {
          scope.$watch(matchDirectiveId, function () {
            control.$validate();
          });

          control.$validators[matchDirectiveId] = function (modelValue, viewValue) {
            var value = modelValue || viewValue;
            var password = scope[matchDirectiveId];
            return value === password;
          };
        }
      };

      d.scope[matchDirectiveId] = "=";

      return d;
    });

  // Determines if an account name already exists in SSO
  angular
    .module("app")
    .directive(uniqueAccountNameDirectiveId, ["$http", "$q", function ($http, $q) {
      return {
        require: "ngModel",
        link: function (scope, elem, attrs, ngModel) {
          ngModel.$asyncValidators[uniqueAccountNameDirectiveId] = function (modelValue, viewValue) {

            if (!viewValue) {
              return $q.when(true);
            }

            var deferred = $q.defer();

            //todo: add caching for ajax calls like this to prevent them from being called with the same parameters multiple times.
            $http.get("/api/Account/Exists?accountName=" + encodeURIComponent(viewValue)).then(function (resp) {
              if (resp.data.Exists === true) {
                deferred.reject();
              } else {
                deferred.resolve();
              }
            }).catch(function () {
              deferred.reject();
            });

            return deferred.promise;
          };
        }
      };
    }]);

  // Determines if an account name already exists in SSO associated with PCMiler Website
  angular
    .module("app")
    .directive(accountInUseDirectiveId, function () {
      return {
        restrict: "A",
        require: "ngModel",
        scope: {
          match: "="
        },
        link: function (scope, element, attr, control) {
          control.$validators[accountInUseDirectiveId] = function (modelValue, viewValue) {
            var value = modelValue || viewValue;

            // if neither viewValue or modelValue is set, return valid - The required validator takes care of making sure the value is set.
            if (value == null) {
              return true;
            }

            var accountId = parseInt(value);

            // the account Id is set to -1 on the hdnAccountId element when
            return accountId >= 0;
          };
        }
      };
    });

  // Determines if a verification token is valid for an emails address
  angular
    .module("app")
    .directive(verificationTokenDirectiveId, ["$http", "$q", function ($http, $q) {
      return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
          ngModel.$asyncValidators[verificationTokenDirectiveId] = function (modelValue, viewValue) {
            if (!viewValue) {
              return $q.when(true);
            }

            var deferred = $q.defer();

            var email = attrs[verificationTokenDirectiveId];
            if (email == null || email === "") {
              return $q.when(true);
            }

            $http.post("/api/Signup/ValidateToken?email=" + encodeURIComponent(email) + "&token=" + viewValue)
              .success(function (response) {
                if (response.IsValid) {
                  deferred.resolve();
                } else {
                  deferred.reject();
                }
              }).error(function () {
                deferred.reject();
              });

            return deferred.promise;
          };
        }
      };
    }]);

  angular
    .module("app")
    .directive("uniqueFavoriteName", [
      "_", "favoriteNameValidator", "$q",
      function (_, favoriteNameValidator, $q) {
        return {
          restrict: "A",
          require: "ngModel",
          link: function (scope, element, attrs, ngModel) {
            ngModel.$asyncValidators["uniqueFavoriteName"] = function (modelValue, viewValue) {
              if (viewValue == null) {
                return $q.resolve(true);
              }

              return favoriteNameValidator.isNameUnique(viewValue);
            };
          }
        };
      }]);

  angular
    .module("app")
    .directive("pcmEmail", function () {
      var REGEX_EMAIL = /^([\w?^_.+-]+\w)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;

      return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
          ngModel.$validators.pcmEmail = function (modelValue) {
            if (modelValue == null || modelValue === "") {
              return true;
            }
            return REGEX_EMAIL.test(modelValue);
          };
        }
      };
    });

    angular
    .module("app")
    .directive("accountEmail", function () {
      var REGEX_EMAIL = /^([\w?^_.-]+\w)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;

      return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
          ngModel.$validators.accountEmail = function (modelValue) {
            if (modelValue == null || modelValue === "") {
              return true;
            }
            return REGEX_EMAIL.test(modelValue);
            
          };      

        }
      };
    });



  angular
    .module("app")
    .directive("pcmUnique", function () {
      return {
        restrict: "A",
        scope: {
          "items": "="
        },
        require: "ngModel",
        link: function (scope, elem, attrs, ngModel) {

          scope.$watch("items", function (newValue, oldValue) {
            var count = 0;
            var value = ngModel.$viewValue;

            for (var i = 0; i < newValue.length; i++) {
              // TODO: make this more generic so 'email' is not hard coded here.  How to take the newvalue[i] and get the $viewValue from it?
              if (newValue[i].email === value) {
                count++

                if (count > 1) {
                  ngModel.$setValidity("pcmUnique", false);
                  return;
                }
              }
            }

            ngModel.$setValidity("pcmUnique", true);

          }, true);
        }
      };
    });

  // Determines if an account name already exists in SSO
  angular
    .module("app")
    .directive("uniqueUsername", ["$q", "signupService", function ($q, signupService) {
      return {
        require: "ngModel",
        link: function (scope, elem, attrs, ngModel) {
          ngModel.$asyncValidators.uniqueUsername = function (modelValue, viewValue) {

            if (!viewValue) {
              return $q.when(true);
            }

            var deferred = $q.defer();

            signupService.userExists(viewValue).then(function (resp) {
              if (resp.data.Exists === true) {
                deferred.reject();
              } else {
                deferred.resolve();
              }
            }).catch(function () {
              deferred.reject();
            });

            return deferred.promise;
          };
        }
      };
    }]);


  angular
    .module("app")
    .directive("alkPassword", function ($compile) {
      return {
        restrict: "A",
        require: "ngModel",
        scope: {
        },
        link: function (scope, element, attrs, ngModel) {

          ngModel.$validators.alkPassword = function (password) {
            if (password == null || password === "") {
              return true;
            }
            var validationObj = {};
            validationObj.length = password.length >= 8 && password.length <= 20;
            validationObj.lowercase = /[a-z]/.test(password);
            validationObj.uppercase = /[A-Z]/.test(password);
            validationObj.number = /\d/.test(password);
            validationObj.specialCharacter = /[!@#\$%&\*\^_\-\+]/.test(password);
            validationObj.overall = Object.values(validationObj).every(function (isTrue) {
              return isTrue;
            });
           return validationObj.overall;
          };
          ngModel.$validators.hasLength = function (password) {
            if (password == null || password === "") {
              return true;
            }
            var length = password.length >= 8 && password.length <= 20;
           return length;
          };
          ngModel.$validators.hasLowercase = function (password) {
            if (password == null || password === "") {
              return true;
            }
            var lowercase = /[a-z]/.test(password);
           return lowercase;
          };
          ngModel.$validators.hasUppercase = function (password) {
            if (password == null || password === "") {
              return true;
            }
            var uppercase = /[A-Z]/.test(password);
           return uppercase;
          };
          ngModel.$validators.hasNumber = function (password) {
            if (password == null || password === "") {
              return true;
            }
            var number = /\d/.test(password);
           return number;
          };
          ngModel.$validators.hasCharacter = function (password) {
            if (password == null || password === "") {
              return true;
            }
            var specialCharacter = /[!@#\$%&\*\^_\-\+]/.test(password);
           return specialCharacter;
          };
        }
      };
    });

})(angular);



// WEBPACK FOOTER //
// ./app/components/validation.directive.js